module.exports = __webpack_public_path__ + "img/ece6e12.png";